<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
interface EulaProps {
  showHeadline?: boolean;
  showAcceptDeclineButtons?: boolean;
}

defineProps<EulaProps>();

const emit = defineEmits<{
  (e: 'accept'): void;
  (e: 'decline'): void;
}>();
</script>

<template>
  <div class="w-100 h-100">
    <h4 v-if="showHeadline" class="h4">{{ $t('EndUserLicenseAgreement') }}</h4>

    <object
      data="/downloads/PTW_EULA.pdf#toolbar=0&navpanes=0&scrollbar=0"
      type="application/pdf"
      width="100%"
      height="100%"
      style="border: none; min-width: 800px; min-height: 600px"
    >
      <p>
        Your browser does not support PDFs.
        <a href="/downloads/PTW_EULA.pdf" target="_blank">Download PDF</a>
      </p>
    </object>

    <div v-if="showAcceptDeclineButtons" class="ma-4">
      <Button class="mr-4" variant="secondary" :label="$t('IDecline')" @click="emit('decline')" />
      <Button variant="primary" :label="$t('IAccept')" @click="emit('accept')" />
    </div>
  </div>
</template>
